import Api from '../../../component/Api';
import { getCookie, deleteCookie } from './cookies';

export const handleAuthSuccess = (authData) => {
    if (typeof authData === 'string' && authData.trim()) {
        localStorage.setItem('token', authData);
    } else {
        localStorage.removeItem('token');
    }
};

export const exchangeSSOCode = async () => {
    const { http } = Api();
    const code = getCookie('mgu_tis_st');

    if (!code) {
        throw new Error('SSO code not found in cookies');
    }

    const response = await http.post(
        '/is/sso/exchangeSSOCode',
        { code },
        {
            withCredentials: false,
        }
    );

    handleAuthSuccess(response.data.token);
    deleteCookie('mgu_tis_st');

    return response.data;
};